import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { UsageScreenProvider, useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { SearchResultViewTracker, getPageViewedEvent, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback, useEffect, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { GET_ALL_PUBLISHED_COLLECTIONS_QUERY as GET_ALL_PUBLISHED_COLLECTIONS_QUERY_PUBLIC } from '../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/SelfServePublicRpc.dfc.new';
import { GET_ALL_PUBLISHED_COLLECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/SelfServeRpc.dfc.new';
import { CollectionCard } from '../collections/components/CollectionCard';
import { UnifiedHeader } from '../components/headers/UnifiedHeader';
import { Screens } from '../constants/usage';
import { useAppContextQuery } from '../hooks/useAppContextQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FeaturedPage() {
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.FEATURED,
    children: /*#__PURE__*/_jsx(FeaturedPageContent, {})
  });
}
export function FeaturedPageContent() {
  var _data$result2;
  const {
    data,
    loading,
    error
  } = useAppContextQuery({
    app: GET_ALL_PUBLISHED_COLLECTIONS_QUERY,
    public: GET_ALL_PUBLISHED_COLLECTIONS_QUERY_PUBLIC
  });
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      lg: false
    }
  });
  const collections = useMemo(() => {
    var _data$result;
    return (data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 || (_data$result = _data$result.collections) === null || _data$result === void 0 ? void 0 : _data$result.filter(collection => collection.displayed !== false).sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))) || [];
  }, [data === null || data === void 0 || (_data$result2 = data.result) === null || _data$result2 === void 0 ? void 0 : _data$result2.collections]);
  useEffect(() => {
    trackMarketplaceEvent(getPageViewedEvent({}));
  }, [trackMarketplaceEvent]);
  const trackButtonClicked = useCallback((id, index) => {
    trackMarketplaceEvent(getSearchResultClickedEvent({
      listingId: id,
      resultCount: collections.length,
      resultIndex: index,
      resultType: 'COLLECTION',
      slug: collections[index].slug
    }));
  }, [collections, trackMarketplaceEvent]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!!data && /*#__PURE__*/_jsx(NavMarker, {
      name: "FEATURED_LOAD"
    }), /*#__PURE__*/_jsx(DashboardPage, {
      headerComponent: /*#__PURE__*/_jsx(UnifiedHeader, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featured.title"
        }),
        pathKey: "FEATURED",
        dataTestId: "featured-page-header",
        isHomePage: false
      }),
      children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        size: "medium",
        marginBlockStart: "800"
      }) : error ? /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest"
      }) : /*#__PURE__*/_jsx(CardGrid, {
        columns: isMobile ? 1 : 2,
        gap: "400",
        children: collections.map((collection, index) => /*#__PURE__*/_jsx(SearchResultViewTracker, {
          listingId: collection.id,
          resultCount: collections.length,
          resultIndex: index,
          resultType: "COLLECTION",
          slug: collection.slug,
          children: /*#__PURE__*/_jsx(CollectionCard, {
            description: collection.description,
            name: collection.name,
            onClick: () => trackButtonClicked(collection.id || 0, index),
            slug: collection.slug,
            previewItems: collection.previewItems,
            totalItemCount: collection.itemCount
          })
        }, `${collection.slug}-${index}`))
      })
    })]
  });
}